import React from "react";
import ReactModal from "react-modal";
import CloseBtn from "../../buttons/CloseBtn";
import { Form } from "react-bootstrap";
import RequieredInputs from "../../common/RequiredInputs";

const NewBusinessUnitModal = ({
  modalIsOpen,
  closeModal,
  newBusinessUnit,
  handleChange,
  handleSubmit,
  validateForm,
  textBtn,
}) => {
  const customStyles = {
    content: {
      width: "60%",
    },
  };

  return (
    <ReactModal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel="Nueva Unidad de Negocio"
      className="custom-modal"
      ariaHideApp={false}
      style={customStyles}
    >
      <span className="custom-modal__close close-btn" onClick={closeModal}>
        <CloseBtn />
      </span>
      <h4 className="custom-modal__title">Nueva Unidad de Negocio</h4>
      <Form className="products__form">
        <div>
          <Form.Group controlId="product-name">
            <Form.Label className="form__labels">
              Nombre <RequieredInputs />{" "}
            </Form.Label>
            <Form.Control
              className="user-input name"
              type="text"
              name="nombre"
              value={newBusinessUnit.nombre}
              onChange={handleChange}
              placeholder="Nombre de la Unidad de Negocio"
            />
            <Form.Label className="form__labels">Descripción</Form.Label>
            <Form.Control
              className="user-input description"
              type="text"
              name="descripcion"
              value={newBusinessUnit.descripcion}
              onChange={handleChange}
              placeholder="Descripción de la Unidad de Negocio"
            />
          </Form.Group>
        </div>
        <button onClick={handleSubmit} disabled={!validateForm()} className="btn save create">
          {textBtn}
        </button>
      </Form>
    </ReactModal>
  );
};
ReactModal.setAppElement("#root");
export default NewBusinessUnitModal;
